import {
  GetString,
} from 'fluent-react';
import React from 'react';
import { Location } from '../../graphQL/types/shared';
import { gql, useQuery } from '../../graphQL/useQuery';
import { getCountryName } from '../../Utils';
import HowToRead from './ProductSpaceHowToRead';
import {
  ContentContainer,
  IntroText,
  Title,
} from './SharedStyling';
import Slide from './Slide';
import SlideAdvancer, { Direction } from './SlideAdvancer';

const query = gql`
  query ExportComplexitySideBar($locationId: ID!) {
    location(id: $locationId) {
      id
      shortName
      nameAbbr
      thePrefix
    }
  }
`;

interface SuccessResponse {
  location: null | {
    id: Location['id']
    shortName: Location['shortName'],
    nameAbbr: Location['nameAbbr']
    thePrefix: Location['thePrefix'],
  };
}

interface Variables {
  locationId: string;
}

interface Props {
  onNextSlideClick: () => void;
  onPrevSlideClick: () => void;
  getFluentString: GetString;
  countryId: string;
  isHelpActive: boolean;
  helpTooltipIndex: number;
}

export default (props: Props) => {
  const {
    onNextSlideClick, onPrevSlideClick, getFluentString,
    countryId, isHelpActive, helpTooltipIndex,
  } = props;

  const variables: Variables = {
    locationId: countryId,
  };

  const {loading, error, data} = useQuery<SuccessResponse, Variables>(query, {variables});
  let output: React.ReactElement<any> | null;
  if (loading === true) {
    output = null;
  } else if (error !== undefined) {
    console.error(error);
    output = null;
  } else if (data !== undefined) {
    const {location} = data;
    if (location === null) {
      output = null;
    } else {
      const { shortName, nameAbbr, thePrefix } = location;
      const {namePrimary} = getCountryName({shortName, nameAbbr, thePrefix: Boolean(thePrefix)});
      output = (
        <>
          <SlideAdvancer
            onClick={onPrevSlideClick}
            direction={Direction.Previous}
            isHelpActive={isHelpActive}
            helpTooltipIndex={helpTooltipIndex}
            getFluentString={getFluentString}
          >
            {getFluentString('section-nav-slide-diversification-paths')}
          </SlideAdvancer>
          <ContentContainer>
            <Title>{getFluentString('section-nav-slide-diversification-countries-paths', {
              'country-name': shortName,
            })}</Title>
            <IntroText>{getFluentString('country-product-space-para-1')}</IntroText>
            <IntroText>{getFluentString('country-product-space-para-2', {
                'country-name': namePrimary,
              })}
            </IntroText>
            <HowToRead getFluentString={getFluentString}/>
          </ContentContainer>
          <SlideAdvancer
            onClick={onNextSlideClick}
            direction={Direction.Next}
            isHelpActive={isHelpActive}
            helpTooltipIndex={helpTooltipIndex}
            getFluentString={getFluentString}
          >
            {getFluentString('section-nav-slide-diversification-strategic-approach', {
              'country-name': shortName,
            })}
          </SlideAdvancer>
        </>
      );
    }
  } else {
    output = null;
  }
  return (
    <Slide>
      <>
        {output}
      </>
    </Slide>
  );
};
